//Does not run untrusted javascript code according to: https://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript
const htmlDecode = (input) => {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}

export { htmlDecode };